<template>
  <section class="login-container">
    <div class="logo">
      <img src="../assets/logo.png" alt />
    </div>
    <div class="login-box">
      <h1>CHI Roster</h1>
      <p>
        Access only granted to users with a @chinet.org email address. Use your
        chi email to login.
      </p>
      <hr />
      <button class="btn" @click="login">Login with Google</button>
    </div>
  </section>
</template>

<script>
import { LoaderPlugin } from "vue-google-login";
import Vue from "vue";

Vue.use(LoaderPlugin, {
  client_id:
    "280433113103-encb95qml98rf4gqrhbejj2eml1rojsm.apps.googleusercontent.com"
});

export default {
  name: "Login",
  data() {
    return {};
  },
  methods: {
    login() {
      Vue.GoogleAuth.then(auth2 => {
        auth2.signIn().then(() => {
          this.$router.push({ name: "home" });
        });
      });
    }
  },
  created() {
    Vue.GoogleAuth.then(auth2 => {
      if (auth2.isSignedIn.get()) {
        this.$router.push({ name: "home" });
      }
    });
  }
};
</script>

<style scoped>
.logo {
  margin-bottom: 30px;
  margin-top: -80px;
}

.logo img {
  width: 150px;
}

.login-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #921b32;
}

.login-box {
  display: flex;
  flex-direction: column;
  background: #fefefe;
  max-width: 380px;
  width: 350px;
  height: 300px;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #921b32;
  font-size: 1.5rem;
  text-align: center;
}

p {
  text-align: center;
}

hr {
  display: block;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin: 30px 0;
  width: 100%;
}
</style>
